function set_date() {
        let datepic = document.querySelector("#date_picker").value;
        console.log("Selected date:", datepic);

        let t = datepic.split("-")[2],
            e = datepic.split("-")[1],
            o = datepic.split("-")[0];
      
        // Set the formatted date in the Date of Birth input
        document.querySelector("input[name='properties[Date of Birth]']").value = `${e}/${t}/${o}`;
        document.querySelector("input[name='properties[Date of Birth]']").dispatchEvent(new Event('change'));
     
    }
  
const unlock_free_questions = () => {
        const freeQuestionsHolder = document.querySelector(".free_3_questions_holder");
        if (freeQuestionsHolder) {
            freeQuestionsHolder.setAttribute('status', 'unlocked');
            const formDataElement = freeQuestionsHolder.querySelector(".form_data");
            if (formDataElement) {
                formDataElement.classList.remove('disabled');
            }
            // const topOffset = freeQuestionsHolder.getBoundingClientRect().top + window.scrollY - 100;
            // window.scrollTo({ top: topOffset, behavior: 'smooth' });
        }
    }

const lock_free_questions = ()=>{
      const freeQuestionsHolder = document.querySelector('.free_3_questions_holder');
            if (freeQuestionsHolder) {
                freeQuestionsHolder.setAttribute('status', 'locked');
            }
      const formDataElement = document.querySelector('.free_3_questions_holder .form_data');
          if (formDataElement) {
              formDataElement.classList.add('disabled');
              formDataElement.value = ''; 
          }
   }

setInterval(() => {
    let formLength = '{{ pluevalue }}';
    let allFilled = true;
        for (let i = 1; i <= formLength; i++ ){
            let selectInput = document.querySelector(`input[name="properties[Question ${i}]"]`).value;
            
            if (selectInput.trim() === '') {
                allFilled = false; 
                break; 
            }
        }
          if (!allFilled) {
           lock_free_questions();
        } else {
            unlock_free_questions();
        }
  },500);

document.addEventListener("DOMContentLoaded", () => {
    const interval = setInterval(() => {
        const $element = $(".text-sm[for='CartSpecialInstructions']");
        if ($element.length) {
            $element.click(function(){
                $("data-island.contents[x-data=CartNote]").slideToggle();
            });
            clearInterval(interval);
        }
    }, 500);
});


$(document).ready(function() {
    // Function to attach click events to checkboxes
    function attachCheckboxEvents() {
        const checkboxes = $(".custom-check-box");
     
        if (checkboxes.length > 0) {
            checkboxes.off('click').on('click', function() {
                const variantId = $(this).val();
                if ($(this).is(":checked")) {
                    addToCart(variantId);
                } else {
                    removeFromCart(variantId);
                }
            });
        }
    }

    // Function to attach click events to cart upsell
    function attachCartUpsellEvents() {
        const cartUpsell = $("#cartupsell");
        if (cartUpsell.length > 0) {
            cartUpsell.off('click').on('click', function() {
                const variantId = $(this).val();
                if ($(this).is(":checked")) {
                    addToCart(variantId);
                } else {
                    removeFromCart(variantId);
                }
            });
        }
    }

    // Set interval to attach events to checkboxes
    const intervalIds = setInterval(() => {
        attachCheckboxEvents();
        // Clear the interval once checkboxes are found and events are attached
        if ($(".custom-check-box").length >= 2) {
             clearInterval(intervalIds);
        }
    }, 500);

    // Set interval to attach events to cart upsell
    const cartIntervalId = setInterval(() => {
        attachCartUpsellEvents();
        // Clear the interval once cart upsell is found
        if ($("#cartupsell").length > 0) {
            clearInterval(cartIntervalId);
        }
    }, 500);

    // Add to cart function
    function addToCart(variantId) {
        $.ajax({
            url: '/cart/add.js',
            type: 'post',
            dataType: 'json',
            data: { items: [{ id: variantId, quantity: 1 }] },
            success: function(response) {
                
                updateCartItems(variantId);
            },
            error: function(error) {
                console.error('Error adding product to cart:', error);
                alert('Failed to add item to cart. Please try again.'); // User feedback
            }
        });
    }

    // Remove product from cart
    function removeFromCart(variantId) {
        $.ajax({
            url: '/cart/change.js',
            type: 'post',
            dataType: 'json',
            data: {
                id: variantId,
                quantity: 0 // Setting quantity to 0 removes the item
            },
            success: function(response) {
                
                updateCartItems(); // Update without variantId as it's not needed here
            },
            error: function(error) {
                console.error('Error removing product from cart:', error);
                alert('Failed to remove item from cart. Please try again.'); // User feedback
            }
        });
    }

    // Get and update cart items
    async function updateCartItems(variantIdCheck) {
        try {
            const response = await fetch("/cart.js");
            const cart = await response.json();
            const cartCountElement = document.querySelector('[x-text="$store.cart_count.count"]');
            const priceElement = document.querySelector('.custom-upsell-price');
            const checkboxElements = document.querySelectorAll('.custom-check-box');
            const getLocalCurrency = localStorage.getItem('Currency Symblo');
          
          console.log("CK DATA",cart);
            // Update cart item count
            if (cartCountElement) {
                cartCountElement.textContent = cart.item_count;
            }

            // Update price
           if (priceElement) {
            let formattedPrice;
            const currency = cart.currency;
            const totalPrice = cart.total_price;
          
            if (currency === "COP") {
              formattedPrice = (totalPrice / 100000);
              priceElement.textContent = `${getLocalCurrency}${formattedPrice}`;
            } else if (currency === "EURO" || currency === "GBP" || currency === "USD"  ||  currency === "CAD" ||  currency === "AUD" || currency === "AED") {
              formattedPrice = (totalPrice / 100).toFixed(2);
              priceElement.textContent = `${getLocalCurrency}${formattedPrice}`;
            }else{
              formattedPrice = (totalPrice / 100).toFixed(2);
              priceElement.textContent = `${getLocalCurrency}${formattedPrice}`;
            }
          }


            // Update checkboxes based on cart items
            checkboxElements.forEach((checkboxElement) => {
                const isVariantInCart = cart.items.some(item => item.variant_id === parseInt(checkboxElement.value));
                checkboxElement.checked = isVariantInCart; // Check/uncheck checkbox
            });

        } catch (error) {
            console.error('Error fetching cart items:', error);
            alert('Failed to fetch cart items. Please try again.'); // User feedback
        }
    }
});


